/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation } from '@tanstack/react-query'
import { ErrorModel } from '@/shared/api/BaseAPI.model'
import ChatBotAPI from '../api/ChatBotAPI'

export function useChatBotQuery() {
  const { mutate: postMessage, isPending } = useMutation<any, ErrorModel, any>({
    mutationFn: (message: string) => ChatBotAPI.postMessage(message)
  })

  return {
    postMessage,
    isPending
  }
}
